import { toast } from "react-toastify";

const useToastError = () => {
  const showErrorToast = (error) => {
    const errorData = error.response?.data?.errors;
    const errorMessage = error.response?.data?.message;

    if (Array.isArray(errorData)) {
      errorData.forEach((err) => {
        toast.error(err.msg, { position: "top-right", autoClose: 3000 });
      });
    } else if (errorMessage) {
      toast.error(errorMessage, { position: "top-right", autoClose: 3000 });
    } else {
      toast.error("An unexpected error occurred", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return { showErrorToast };
};

export default useToastError;
